import { List } from "semantic-ui-react";
import { RegisterAssignment } from "../models/RegisterAssignment";
import { groupAssignmentsByProject } from "../utils/registerAssignment";

interface Props {
  assignments: RegisterAssignment[];
}

const UserAssignmentsTreeView = ({ assignments }: Props) => {
  if (!assignments || assignments.length === 0) {
    return <p>No assignments found.</p>;
  }

  return (
    <List relaxed>
      {groupAssignmentsByProject(assignments).map(({ projectName, registers }) => (
        <List.Item key={projectName}>
          <List.Icon name="tasks" />
          <List.Content>
            <List.Header>{projectName}</List.Header>
            <List.List>
              {registers.map(({ registerId, registerTitle, assignments }) => (
                <List.Item key={registerId}>
                  <List.Icon name="boxes" />
                  <List.Content>
                    <List.Header>{registerTitle}</List.Header>
                    <List.List>
                      {assignments.map((a) => (
                        <List.Item key={a.id}>
                          <List.Icon name="clipboard outline" />
                          <List.Content>
                            <List.Header>{a.permitTypeOrgRole.permitType.name}</List.Header>
                            <List.Description>{a.permitTypeOrgRole.orgRole.displayName}</List.Description>
                          </List.Content>
                        </List.Item>
                      ))}
                    </List.List>
                  </List.Content>
                </List.Item>
              ))}
            </List.List>
          </List.Content>
        </List.Item>
      ))}
    </List>
  );
};

export default UserAssignmentsTreeView;
